// extracted by mini-css-extract-plugin
export default {"section":"XEoMBoIa6aBgLUZBiPm6","subHeader":"u1BrzxcxDZs_ypVD5GBn","subHeaderIcon":"za0heBEEWYGA0zykOkBH","subHeaderText":"WIEcIyrj3cfRlOaUDktw","pulse":"dom7Da4lSzdtN2vg4dvk"};